module.exports = __webpack_public_path__ + "img/cake-13.0c434ed5.svg";